import gql from 'graphql-tag'

export const GET_TRADE_ORDERS = gql`
  query {
    getTradeOrders {
      trade_order_id
      qty
      status
      rule
      tradeStock {
        name
      }
      history {
        trade_order_history_id
        status
        created_at
        response_log
      }
    }
  }
`